"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpstreamSupportToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "safeMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class UpstreamSupportToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.UpstreamSupportToken__factory = UpstreamSupportToken__factory;
UpstreamSupportToken__factory.bytecode = _bytecode;
UpstreamSupportToken__factory.abi = _abi;
